import React from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { CheckCircle } from "lucide-react";
import { useB2BAuth } from "../../B2BShared/B2BAuthContext/B2BAuthContext";
import "./B2BApprovalSuccess.css";

const B2BApprovalSuccess: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { logout } = useB2BAuth();
  const action = searchParams.get("action");
  const userName = searchParams.get("user");

  const handleBackToHome = () => {
    logout();
    navigate("/gcb");
  };

  return (
    <div className="b2b-approval-result">
      <div className="b2b-approval-result-card">
        <div className="b2b-approval-result-icon success">
          <CheckCircle size={64} />
        </div>
        <h1 className="b2b-approval-result-title">Success!</h1>
        <p className="b2b-approval-result-message">
          {action === "approved" ? (
            <>
              User <strong>{userName || "the user"}</strong> has been{" "}
              <strong>approved</strong> successfully.
              <br />
              <br />
              They will receive a confirmation email and can now access their GCB
              dashboard.
            </>
          ) : action === "rejected" ? (
            <>
              User <strong>{userName || "the user"}</strong> has been{" "}
              <strong>rejected</strong>.
              <br />
              <br />
              They will receive a notification email about this decision.
            </>
          ) : (
            "Action completed successfully."
          )}
        </p>
        <div className="b2b-approval-result-actions">
          <button
            onClick={handleBackToHome}
            className="b2b-approval-result-button"
          >
            Back to GCB Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default B2BApprovalSuccess;

